exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.row[data-v-56a3c480] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.error[data-v-56a3c480] {\n  width: 160px;\n  color: #dd5555;\n  position: absolute;\n  top: -4px;\n  left: 0;\n  padding: 4px 8px;\n  background: #fff;\n  border: solid 2px #dd5555;\n}\n.opponent[data-v-56a3c480] {\n  text-align: right;\n  line-height: 32px;\n}\n.status[data-v-56a3c480],\n.title[data-v-56a3c480] {\n  margin: 0;\n  position: relative;\n  line-height: 32px;\n}\n", ""]);

// exports
